module.exports = __webpack_public_path__ + "static/img/7.ef975f8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/mobile/assets/images/partners/pinterest/7.jpeg
// module id = fHB+
// module chunks = 46